import React from 'react';
import { Row, Col } from 'antd';
import UserProfileImage from './UserProfileImage';

const ServiceProviderProfile = ({
  classNameRow,
  className,
  profileImage = {},
  name,
  professionalName,
  medicalSpecialties = [],
  crm
}) => {
  const specialty =
    medicalSpecialties.length > 0
      ? medicalSpecialties[0].medicalSpecialty?.professionalTitle
      : null;

  return name ? (
    <Row
      className={`no-margin no-padding gx-mb-0 gx-mt-2 gx-flex-nowrap ${classNameRow}`}
      align="middle"
      justify="start"
    >
      <Col>
        <UserProfileImage
          {...profileImage}
          name={name}
          className={className ?? `ant-avatar gx-size-35 gx-pointer gx-mr-2`}
        />
      </Col>
      <Col>
        <div className="gx-fs-ms">{professionalName ?? name}</div>
        {specialty ? (
          <div className="gx-fs-11">
            {`${specialty}${crm ? ` / CRM ${crm}` : ''}`}
          </div>
        ) : null}
      </Col>
    </Row>
  ) : null;
};

export default ServiceProviderProfile;
